export const isOCRSubmitAllowed = (
  isSubmitValid,
  isOCRTracApp,
  isTRACSubmitValid,
  consentAgreement,
  userHaveExistingAgreements
) => {
  if (userHaveExistingAgreements && !isOCRTracApp) {
    return isSubmitValid;
  }
  if (isOCRTracApp) {
    return isTRACSubmitValid;
  }
  return isSubmitValid && consentAgreement;
};

export const checkValid = (infoValid, beneInfoValid, portfolioValid) =>
  infoValid && beneInfoValid && portfolioValid;

export const doneMode = (editCustomer, editBeneInfo, editPortfolio) =>
  !(editCustomer || editBeneInfo || editPortfolio);

const checkDeliveryMethod = (
  deliveryMethodValid,
  userHaveExistingAgreements
) => {
  if (userHaveExistingAgreements) {
    return true;
  }
  return deliveryMethodValid;
};

const checkEditDeliveryMethod = (
  userHaveExistingAgreements,
  editDeliveryMethod
) => {
  if (userHaveExistingAgreements) {
    return false;
  }
  return editDeliveryMethod;
};

export const checkSubmitValid = (
  infoValid,
  beneInfoValid,
  portfolioValid,
  paperlessConsentValid,
  deliveryMethodValid,
  userHaveExistingAgreements
) =>
  checkValid(infoValid, beneInfoValid, portfolioValid) &&
  paperlessConsentValid &&
  checkDeliveryMethod(deliveryMethodValid, userHaveExistingAgreements);

export const allSectionsInDoneMode = (
  editCustomer,
  editBeneInfo,
  editPortfolio,
  editPaperless,
  editDeliveryMethod,
  userHaveExistingAgreements
) =>
  !(
    editCustomer ||
    editBeneInfo ||
    editPortfolio ||
    editPaperless ||
    checkEditDeliveryMethod(userHaveExistingAgreements, editDeliveryMethod)
  );

const checkParticipantLoanBalance = (
  participantStatus,
  participantAge,
  participantLoanBalance,
  participantCashDistribution
) =>
  Boolean(
    participantStatus &&
      participantAge &&
      participantLoanBalance &&
      participantCashDistribution
  );

export const areParticipantDetailsValid = (
  participantStatus,
  participantAge,
  participantLoanBalance,
  participantCashDistribution
) => {
  if (participantLoanBalance === 'YES') {
    return checkParticipantLoanBalance(
      participantStatus,
      participantAge,
      participantLoanBalance,
      participantCashDistribution
    );
  }
  return Boolean(participantStatus && participantAge && participantLoanBalance);
};

const validateWhenNOPaperlessWithdrawls = (
  paperlessWithdrawls,
  distributionStatus,
  rolloverOptionsNotice
) =>
  Boolean(paperlessWithdrawls && distributionStatus && rolloverOptionsNotice);

const checkNonParticipantDetailsValid = (
  paperlessWithdrawls,
  brokerageAssets,
  distributionStatus,
  rolloverOptionsNotice
) =>
  Boolean(
    paperlessWithdrawls &&
      brokerageAssets &&
      distributionStatus &&
      rolloverOptionsNotice
  );

export const isTRACDistributionValid = (
  paperlessWithdrawls,
  participantStatus,
  participantAge,
  brokerageAssets,
  participantLoanBalance,
  participantCashDistribution,
  distributionStatus,
  rolloverOptionsNotice
) => {
  if (paperlessWithdrawls === 'NO') {
    return validateWhenNOPaperlessWithdrawls(
      paperlessWithdrawls,
      distributionStatus,
      rolloverOptionsNotice
    );
  }
  return (
    checkNonParticipantDetailsValid(
      paperlessWithdrawls,
      brokerageAssets,
      distributionStatus,
      rolloverOptionsNotice
    ) &&
    areParticipantDetailsValid(
      participantStatus,
      participantAge,
      participantLoanBalance,
      participantCashDistribution
    )
  );
};

export const displayDistributionSection = (
  isOCRTracApp,
  consentAgreement,
  userHaveExistingAgreements
) => {
  if (isOCRTracApp) {
    if (userHaveExistingAgreements) {
      return true;
    }
    return consentAgreement;
  }
  return false;
};
